var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "row align-middle hkld-footer" }, [
    _c("div", {
      staticClass: "column align-right hkld-footer__copyright",
      domProps: { innerHTML: _vm._s(_vm.footerHml) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }